import "./styles.css";

export default function App() {
  return (
    <>
      <div className="video-bg">
        <video width="320" height="240" autoPlay loop muted>
          <source
            src="https://assets.codepen.io/3364143/7btrrd.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="glass-panel">
        <div className="glass-header">
          <h1>Hello CodeSandbox</h1>
        </div>

        <div className="glass-content">
          <p>Start editing to see some magic happen!</p>

          <div className="card">
            <div className="card__header">사이다</div>
            <div className="card__footer">500</div>
          </div>

          <button className="glass-button">버튼</button>
        </div>
      </div>
    </>
  );
}
